export default {
    // ---------Title--------
    adminProfile: 'Administrator Profile',
    customerProfile: 'Customer Profile',
    fullDetailsOfCustomerInformation: 'Full details of customer information',
    markingInfo: 'Marking Info',
    detailsOfMarkingInformation: 'Details of marking information',
    mainBranchProfile: 'Main Branch Profile',
    mainBranchProfileDetailsInformation: 'Main Branch profile details information',
    mainBranchAddress: 'Main Branch Address',
    mainBranchAddressDetailsInformation: 'Main Branch address details information',
    branches: 'Branches',
    branchProfile: 'Branch Profile',
    branchDetailsInformation: 'Branch Details Information',
    branchUsers: 'Branch Users',
    branchUserDetailsInformation: 'Branch user details information',
    branchAddress: 'Branch Address',
    branchAddressDetailsInformation: 'Branch Address Details Information',
    accessScopes: 'Access Scopes',
    accessPermissionOfScopes: 'Access permission of scopes',
    supplierProfile: 'Profile',
    fullDetailsOfSupplierInformation: 'Full details of supplier information',
    address: 'Address',
    fullAddressDetailsOfSupplierInformation: 'Full address details of supplier information',
    bankInfo: 'Bank Info',
    supplierBankDetails: 'Supplier bank details',
    driverProfile: 'Driver Profile',
    fullDetailsOfDriverInformation: 'Full details of Driver information',
    workerProfile: 'Worker Profile',
    fullDetailsOfWorkerInformation: 'Full details of worker information',
    person: 'Person',
    detailsOfPersonInformation: 'Details of person information',
    detailsOfCompanyInformation: 'Details of company information',
    mainOutletInfo: 'Main Outlet Info',
    fullDetailsOfOutletInformation: 'Full details of outlet information',
    mainOutletAddress: 'Main Outlet Address',
    fullOutletAddressDetailsInformation: 'Full Outlet address details information',
    retailerProfile: 'Retailer Profile',
    fullDetailsOfRetailerInformation: 'Full details of retailer information',
    listOfOutletsInformation: 'List of outlets information',
    outletUsers: 'Outlet Users',
    assignedUsersInformation: 'Assigned users information',
    viewAdministrator: 'View Administrator',
    viewCustomer: 'View Customer',
    viewSupplier: 'View Supplier',
    viewRetailer: 'View Retailer',
    viewDriver: 'View Driver',
    viewMember: 'View Member',
    viewWorker: 'View Worker',
    editProfile: 'Edit Profile',
    administratorProfileDetails: 'Administrator Profile Details',
    customerProfileDetails: 'Customer Profile Details',
    supplierProfileDetails: 'Supplier Profile Details',
    retailProfileDetails: 'Retail Profile Details',
    driverProfileDetails: 'Driver Profile Details',
    memberProfileDetails: 'Member Profile Details',
    workerProfileDetails: 'Worker Profile Details',
    thereIsNoBranchAddedAtTheMoment: 'There is no Branch added at the moment!',
    thereIsNoBranchUserBeenAssignedAtTheMoment: 'There is no Branch User been assigned at the moment!',
    thereIsNoOutletAddedAtTheMoment: 'There is no Outlet added at the moment!',
    thereIsNoOutletUserBeenAssignedAtTheMoment: 'There is no Outlet User been assigned at the moment!',
    outletDetailsInformation: 'Outlet Details Information',
    outletUserDetailsInformation: 'Outlet User Details Information',
    zones: 'Zones',
    zoneAllocationArea: 'Zones Allocation Area',
    thereIsNoZoneBeenAssignedAtTheMoment: 'There is no zone been assigned at the moment!',
    zone: 'Zone',
    rack: 'Rack',

    // ----------MUI----------
    customerCode: 'Customer Code',
    regNo: 'Reg No.',
    registrationNo: 'Registration No.',
    accountCode: 'Account Code (Debtor)',
    salesperson: 'Salesperson',
    branchName: 'Branch Name',
    branchCode: 'Branch Code',
    branchContact: 'Branch Contact',
    branchEmail: 'Branch Email',
    contactName: 'Contact Name',
    contactNo: 'Contact No',
    contactEmail: 'Contact Email',
    branchMarking: 'Branch Marking',
    branchType: 'Branch Type',
    hq: 'HQ',
    mainHQ: 'Main HQ',
    normal: 'Normal',
    addMarking: 'Add Marking',
    createNew: 'Create New',
    new: 'New',
    bankName: 'Bank Name',
    bankAccount: 'Bank Account',
    users: 'Users',
    user: 'User',
    code: 'Code',
    members: 'Members',
    outlets: 'Outlets',
    outlet: 'Outlet',
    business: 'Business',
    differentBusiness: 'Different Busines',
    sameBusiness: 'Same Busines',
    outletName: 'Outlet Name',
    outletCode: 'Outlet Code',
    outletContact: 'Outlet Contact',
    outletEmail: 'Outlet Email',
    outletType: 'Outlet Type',

    primaryRegistrationNo: 'Primary Registration No',
    secondaryRegistrationNo: 'Secondary Registration No',
    taxation: 'Taxation',
    detailsOfTaxationInformation: 'Details of taxation information',
    taxIdentificationNo: 'Tax Identification No.',
    taxRegistrationNo: 'Tax Registration No.',
    excludeTax: 'Exclude Tax',

    // ---------Drawer--------
    newBranch: 'New Branch',
    updateBranch: 'Update Branch',
    newBranchUser: 'New Branch User',
    updateBranchUser: 'Update Branch User',
    mainBranch: 'Main Branch',
    normalBranch: 'Normal Branch',
    shippingAddress: 'Shipping Address',
    newOutlet: 'New Outlet',
    newOutletUser: 'New Outlet User',
    updateOutlet: 'Update Outlet',
    updateOutletUser: 'Update Outlet User',

    outletInfo: 'Outlet Info',
    mainOutlet: 'Main Outlet',
    normalOutlet: 'Normal Outlet',
    outletAddress: 'Outlet Address',

    youHaveNotCreatedAnyItemYet: 'You have not created any item yet.',
};